import { isNaN } from 'lodash-es';

import { FilterValue } from '../../filterValue';
import { define } from './_common';

export const FilterableConditionSetting = define({
    filtersToSetting: (filter, { currentSettings }) => {
        const conditionSetting = currentSettings.CONDITION;
        if (
            !conditionSetting ||
            filter.item !== 'CONDITIONVALUE' ||
            !FilterValue.is.NUMBER(filter.value)
        )
            return null;

        const filterValue = filter.value.value;

        return !isNaN(filterValue)
            ? { CONDITION: { ...conditionSetting, value: filterValue } }
            : null;
    },
});
